export const PetType = [
    { id: 'dog', name: 'Dog' },
    { id: 'cat',  name: 'Cat' },
];
